export default __webpack_public_path__ + "static/media/logo.418ac9a8.webp";